<template>
  <div class="friendship-level-root" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top: ${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" @click-left="closeWeb" />
          <span class="tit-left">
            {{ $t('lang.FriendshipLevel.k031') }}
          </span>
        </template>
        <template #right>
          <div class="more-btn" @click="handleMore">
            <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/more.png" alt="" />
            <transition name="fade">
              <div class="more-list" v-if="showMore">
                <div class="span1" @click="aboutBond">{{ $t('lang.FriendshipLevel.k025') }}</div>
                <div class="line"></div>
                <div class="span2" @click="removeBond" v-if="data.fromGender == 1">{{ $t('lang.FriendshipLevel.k033') }}</div>
              </div>
            </transition>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <!-- 亲密度 -->
    <div class="avatar">
      <img v-show="data.fromAvatar" :src="data.fromAvatar | imgPath" style="object-fit: cover" />
      <div class="level-love">
        <!-- 级别 -->
        <p v-if="data.fromAvatar" class="level-num">
          {{ $t('lang.BaseCommon.k002') }}.
          <span class="friendship-num-font">{{ data.grade }}</span>
        </p>
        <!-- 亲密值 -->
        <p class="intimate-value">
          <span>
            <span class="friendship-num-font">{{ data.togetherDays }}</span>
            &nbsp;
          </span>
          <i>{{ data.togetherDays == 1 ? $t('lang.BaseCommon.k093') : $t('lang.FriendshipLevel.k027') }}</i>
        </p>
      </div>
      <img v-show="data.fromAvatar" :src="data.targetAvatar | imgPath" style="object-fit: cover" />
    </div>

    <!-- 进度条 -->
    <div class="progress">
      <div class="progress-item">
        <van-progress
          class="progress-bar"
          :color="progressBarColor"
          :track-color="progressBarTrackColor"
          :show-pivot="false"
          :percentage="percentageVal"
          stroke-width="11"
        />
        <span class="progress-text" v-if="data.grade == data.nextGrade">{{ $t('lang.BaseCommon.k062') }}</span>
        <span class="progress-text" v-else>
          <span class="friendship-num-font">{{ data.score }}</span>
          /
          <span class="friendship-num-font">{{ data.nextGradeMinScore }}</span>
        </span>
      </div>
    </div>

    <!-- 等级条 -->
    <div class="level">
      <div class="level-item current-level">
        <span>
          {{ $t('lang.BaseCommon.k002') }}.
          <span class="friendship-num-font">{{ data.grade }}</span>
        </span>
      </div>
      <div class="level-tip" @click="handleToRule">
        <template v-if="data.grade == data.nextGrade">{{ $t('lang.FriendshipLevel.k029') }}</template>
        <template v-else>
          <span class="friendship-num-font">{{ data.nextGradeMinScore - data.score }}</span>
          &nbsp;
          {{ data.nextGradeMinScore - data.score == 1 ? $t('lang.BaseCommon.k065') : $t('lang.BaseCommon.k066') }}
          {{ $t('lang.BaseCommon.k049') }}
        </template>
        <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/rules.png" alt="rules" />
      </div>
      <div class="level-item">
        <template>
          <span>
            {{ $t('lang.BaseCommon.k002') }}.
            <span class="friendship-num-font">{{ data.nextGrade }}</span>
          </span>
        </template>
      </div>
    </div>

    <div class="content">
      <!-- 内容卡 -->
      <div class="days">
        <div class="days-text">
          <div class="days-data">
            <span>{{ $t('lang.BaseCommon.k063') }}</span>
            <i>
              <span class="friendship-num-font">{{ data.chatMsgCount }}</span>
            </i>
          </div>
          <div class="days-data">
            <span>{{ $t('lang.BaseCommon.k076') }}</span>
            <i>
              <span class="friendship-num-font">{{ data.presentGiftCount }}</span>
            </i>
          </div>
          <div class="days-data">
            <span>{{ $t('lang.FriendshipLevel.k038') }}</span>
            <i>
              <span class="friendship-num-font">{{ time }}</span>
            </i>
          </div>
        </div>
        <div class="last-chat-time">
          <!-- 用这个方法 handleMoment -->
          {{ $t('lang.FriendshipLevel.k028') }}
          <i>
            <span class="friendship-num-font">{{ handleMoment(data.lastConnectTime, 'DD/MM/YYYY') }}</span>
          </i>
        </div>
      </div>

      <!-- 关系轴 -->
      <div class="reward-list">
        <div class="title">
          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/day_left.png" alt="" />
          <div class="tit">{{ data.fromGender == 1 ? $t('lang.FriendshipLevel.k032') : $t('lang.BaseCommon.k067') }}</div>
          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/day_right.png" alt="" />
        </div>

        <!-- 步骤图-版本1 -->
        <div v-if="data && !data.ifNewRuleFriend" class="steps-box step-v1">
          <!-- 目前数据长度为6 因为等级最大只有6级 -->
          <van-steps direction="vertical" :active="data.grade - 1">
            <van-step v-for="item in rewardList" :key="item.grade">
              <div class="step-item-rewards">
                <!-- 等级 -->
                <div class="reward-level">
                  {{ $t('lang.BaseCommon.k002') }}.
                  <span class="friendship-num-font">{{ item.grade }}</span>
                </div>
                <!-- 左边的宝箱 -->
                <div class="treasure-root" v-if="item.ifRewardProp">
                  <div class="privilege-wrapper">
                    <div class="privilege-item">
                      <div class="image-wrapper">
                        <!-- 打开的 -->
                        <template v-if="item.ifTakeReward">
                          <img
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/chest_unlocked.png"
                            alt=""
                            width="40"
                            height="40"
                            @click="rewardProp(item.props, item.grade)"
                          />
                          <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                        </template>
                        <!-- 没有打开的 -->
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/chest_locked.png" alt="" width="40" height="40" />
                          <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                        </template>
                      </div>
                      <div class="title1">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.FriendshipLevel.k026') }}({{ $t('lang.BaseCommon.k002') }}.
                          <span class="friendship-num-font">{{ item.grade }}</span>
                          )
                        </span>
                      </div>
                      <div class="title2">
                        <template v-if="item.ifTakeReward">{{ $t('lang.FriendshipLevel.k037') }}</template>
                        <template v-else>
                          {{ $t('lang.FriendshipLevel.k035') }}
                          <span class="friendship-num-font">{{ item.grade }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右边的特权 -->
                <div class="privilege-root" v-if="item.ifRewardPrivilege">
                  <!-- 男性 fromGender = 1 -->
                  <template v-if="data.fromGender == 1">
                    <!-- 一级 -->
                    <template v-if="item.grade == 1">
                      <!-- 免费聊天特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img
                                src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_messages.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img
                                src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_messages.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k030') }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 发送图片特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k034') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 三级 -->
                    <template v-if="item.grade == 3">
                      <!-- 私密视频特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_private.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img
                                src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_private.png"
                                alt=""
                                width="40"
                                height="40"
                              />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k036') }}</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 女性 fromGender = 2 -->
                  <template v-else>
                    <!-- 等级start -->
                    <!-- 一级 -->
                    <template v-if="item.grade == 1">
                      <!-- 发送图片特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_send.png" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k034') }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- 2 beans特权 -->
                      <div class="privilege-wrapper" v-if="item.rewardBeanNumber">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">2</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 二级 -->
                    <template v-if="item.grade == 2 && item.rewardBeanNumber">
                      <!-- 20 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">{{ item.rewardBeanNumber }}</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 三级 -->
                    <template v-if="item.grade == 3 && item.rewardBeanNumber">
                      <!-- 50 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">{{ item.rewardBeanNumber }}</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 四级 -->
                    <template v-if="item.grade == 4 && item.rewardBeanNumber">
                      <!-- 100 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">{{ item.rewardBeanNumber }}</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 五级 -->
                    <template v-if="item.grade == 5 && item.rewardBeanNumber">
                      <!-- - 200 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">{{ item.rewardBeanNumber }}</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 六级 -->
                    <template v-if="item.grade == 6 && item.rewardBeanNumber">
                      <!-- 500 beans特权 -->
                      <div class="privilege-wrapper">
                        <div class="privilege-item">
                          <div class="image-wrapper">
                            <template v-if="item.grade <= data.grade">
                              <img :src="getMatchImg('beans')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png" alt="" />
                            </template>
                            <template v-else>
                              <img :src="getMatchImg('beans-off')" alt="" width="40" height="40" />
                              <img class="status-icon" src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/lock_icon.png" alt="" />
                            </template>
                          </div>
                          <div class="title">
                            <span :class="{ 'no-reward-text': item.grade > data.grade }">
                              <span class="friendship-num-font">{{ item.rewardBeanNumber }}</span>
                              &nbsp;{{ $t('lang.BaseCommon.k072') }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 等级end -->
                  </template>
                </div>
              </div>
            </van-step>
          </van-steps>
        </div>

        <!-- 步骤图-版本2 -->
        <div v-else class="steps-box step-v2">
          <template v-if="data.fromGender == 1">
            <div class="step-item-rewards" v-for="item in rewardListNew" :key="item.grade">
              <div class="reward-level">
                {{ $t('lang.BaseCommon.k002') }}.
                <span class="friendship-num-font">{{ item.grade }}</span>
              </div>
              <div class="privilege-root">
                <!-- 一级 -->
                <template v-if="item.grade == 1">
                  <!-- 发送图片特权 -->
                  <div class="privilege-wrapper" id="male-grade1-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_send.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_send.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k034') }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 免费聊天特权 -->
                  <div class="privilege-wrapper" id="male-grade1-type1">
                    <div class="privilege-item" @click="handleGet(item, 1)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_messages.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_messages.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k004') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="item.grade == 2">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade2-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_coupon.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.BaseCommon.k038') }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- chocolate 替换了原来得 gem -->
                  <div class="privilege-wrapper" id="male-grade2-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'gem')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_chocolate.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_chocolate.png"
                            alt=""
                            width="40"
                            height="40"
                          />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[1].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 三级 -->
                <template v-else-if="item.grade == 3">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade3-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_coupon.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.BaseCommon.k038') }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 私密视频特权 -->
                  <div class="privilege-wrapper" id="male-grade3-type1">
                    <div class="privilege-item" @click="handleGet(item, 1)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_private.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_private.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k036') }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 四级 -->
                <template v-else-if="item.grade == 4">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade4-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_coupon.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.BaseCommon.k038') }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- bunnyposy 替换了 rose -->
                  <div class="privilege-wrapper" id="male-grade4-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'rose')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_bunnyposy.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_bunnyposy.png"
                            alt=""
                            width="40"
                            height="40"
                          />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[1].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 五级 -->
                <template v-else-if="item.grade == 5">
                  <!-- 优惠券 -->
                  <div class="privilege-wrapper" id="male-grade5-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_coupon.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.BaseCommon.k038') }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 六级 -->
                <template v-else-if="item.grade == 6">
                  <div class="privilege-wrapper" id="male-grade6-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_coupon.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_coupon.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ $t('lang.BaseCommon.k038') }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- purse 替换了 dream box -->
                  <div class="privilege-wrapper" id="male-grade6-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'dream')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_purse.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_purse.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[1].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-if="data.fromGender == 2">
            <div class="step-item-rewards" v-for="item in rewardListNew" :key="item.grade">
              <div v-if="item.grade == 1 || item.grade == 3 || item.grade == 5" class="reward-level">
                {{ $t('lang.BaseCommon.k002') }}.
                <span class="friendship-num-font">{{ item.grade }}</span>
              </div>
              <div class="privilege-root" v-if="[1, 3, 5].includes(item.grade)">
                <!-- 一级 -->
                <template v-if="item.grade == 1">
                  <!-- 发送图片特权 -->
                  <div class="privilege-wrapper" id="female-grade1-type0">
                    <div class="privilege-item" @click="handleGet(item, 0)">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_send.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_send.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">{{ $t('lang.FriendshipLevel.k034') }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- cocktail -->
                  <div class="privilege-wrapper" id="female-grade1-type1">
                    <div class="privilege-item" @click="handleGet(item, 1, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[1].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[1]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[1].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 三级 -->
                <template v-if="item.grade == 3">
                  <div class="privilege-wrapper" id="female-grade3-type0">
                    <div class="privilege-item" @click="handleGet(item, 0, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[0]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[0].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 五级 -->
                <template v-if="item.grade == 5">
                  <div class="privilege-wrapper" id="female-grade5-type0">
                    <div class="privilege-item" @click="handleGet(item, 0, 'cocktail')">
                      <div class="image-wrapper">
                        <template v-if="item.grade <= data.grade">
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" width="40" height="40" />
                          <img
                            v-if="item.children[0].ifTakeReward"
                            class="status-icon"
                            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_icon.png"
                            alt=""
                          />
                        </template>
                        <template v-else>
                          <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_un_cocktail.png" alt="" width="40" height="40" />
                        </template>
                      </div>
                      <div class="title" v-if="item.children[0]">
                        <span :class="{ 'no-reward-text': item.grade > data.grade }">
                          {{ item.children[0].propName }} x
                          <span class="friendship-num-font">1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>

          <div v-if="rewardListNew && rewardListNew.length" class="reward-bar"></div>
        </div>
      </div>
    </div>

    <!-- 移除关系弹窗 -->
    <ConfirmAuto
      :showDia="showConfirmAuto"
      :title="title"
      :content="content"
      :leftBtnText="leftBtnText"
      :rightBtnText="rightBtnText"
      @leftBtn="leftBtn"
      @rightBtn="rightBtn"
    />

    <!-- 打开宝箱弹窗 -->
    <van-popup class="popup-box" v-model="showProp" :style="cssVars()" @close="closeProp" :lock-scroll="false">
      <div class="prop-tit">
        {{ $t('lang.FriendshipLevel.k026') }}({{ $t('lang.BaseCommon.k002') }}.
        <span class="friendship-num-font">{{ chooseBlockGender }}</span>
        )
      </div>
      <div class="prop" :class="{ 'prop-num': propsList.length > 3 }">
        <div class="prop-content" v-for="(item, index) in propsList" :key="index">
          <img v-if="item.propType == 1" :src="getMatchImg('chat-pass')" alt="" />
          <img v-if="item.propType == 3" :src="getMatchImg('beans')" alt="" />
          <img v-if="item.propType == 9" :src="getMatchImg('coupon')" alt="" />
          <div class="coupon-text">
            <i v-if="item.propType == 1">{{ $t('lang.BaseCommon.k037') }}</i>
            <i v-if="item.propType == 9">{{ $t('lang.BaseCommon.k038') }}</i>
            x
            <span class="friendship-num-font">{{ item.rewardNumber }}</span>
            <span class="tip" v-if="item.extraAmount">
              ({{ $t('lang.BaseCommon.k030') }}
              <span class="friendship-num-font">{{ item.extraAmount }}</span>
              )
            </span>
          </div>
        </div>
      </div>
      <div class="close-btn" @click="closeProp">{{ $t('lang.BaseCommon.k060') }}</div>
    </van-popup>

    <!-- New friendship 弹框 -->
    <div class="dialog-mask" v-if="showNewfriendship && !laterShowNewfriendship" @click.self="showNewfriendship = false">
      <div class="friendship-dialog">
        <div class="friendship-dia-head">
          <span>{{ $t('lang.BaseCommon.k018') }}</span>
          <img src="./images/up-arrow.png" />
        </div>
        <div v-if="data.fromGender === 1" class="friendship-dia-bd">
          <div class="friendship-dia-con">
            <div class="friendship-dia-tit">{{ $t('lang.FriendshipLevel.k005') }}</div>
            <div class="friendship-tips">{{ $t('lang.FriendshipLevel.k006') }}</div>
            <div class="friendship-rewards">
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_chocolate.png" alt="" />
                <span>
                  Lv.
                  <span class="friendship-num-font">2</span>
                </span>
              </div>
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_bunnyposy.png" alt="" />
                <span>
                  Lv.
                  <span class="friendship-num-font">4</span>
                </span>
              </div>
              <div>
                <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_purse.png" alt="" />
                <span>
                  Lv.
                  <span class="friendship-num-font">6</span>
                </span>
              </div>
            </div>
          </div>
          <div class="ok-btn" @click="handleLevelOk">{{ $t('lang.BaseCommon.k088') }}</div>
        </div>

        <div v-if="data.fromGender === 2" class="friendship-dia-bd">
          <van-swipe class="my-swipe" :autoplay="3000">
            <van-swipe-item>
              <div class="friendship-dia-con">
                <div class="friendship-dia-tit">{{ $t('lang.FriendshipLevel.k005') }}</div>
                <div class="friendship-tips">{{ $t('lang.FriendshipLevel.k012') }}</div>
                <div class="friendship-rewards">
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">1</span>
                    </span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">3</span>
                    </span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">5</span>
                    </span>
                  </div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="friendship-dia-con">
                <div class="friendship-dia-tit">{{ $t('lang.FriendshipLevel.k005') }}</div>
                <!-- 男用户 -->
                <div class="friendship-tips">{{ $t('lang.FriendshipLevel.k013') }}</div>
                <div class="friendship-rewards">
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_chocolate.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">2</span>
                    </span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_bunnyposy.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">4</span>
                    </span>
                  </div>
                  <div>
                    <img src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_purse.png" alt="" />
                    <span>
                      Lv.
                      <span class="friendship-num-font">6</span>
                    </span>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="ok-btn" @click="handleLevelOk">{{ $t('lang.BaseCommon.k088') }}</div>
        </div>
      </div>
    </div>

    <!-- Send Gift 弹框 -->
    <div class="dialog-mask" v-if="showSendGift" @click.self="showSendGift = false">
      <div class="sendgift-dialog">
        <div class="sendgift-tit">{{ $t('lang.FriendshipLevel.k007') }}</div>
        <div class="sendgift-rewards">
          <img
            v-if="waitSendObj && waitSendObj.imgType === 'gem'"
            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_chocolate.png"
            alt=""
          />
          <img
            v-if="waitSendObj && waitSendObj.imgType === 'rose'"
            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_bunnyposy.png"
            alt=""
          />
          <img
            v-if="waitSendObj && waitSendObj.imgType === 'dream'"
            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_purse.png"
            alt=""
          />
          <img
            v-if="waitSendObj && waitSendObj.imgType === 'cocktail'"
            src="@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/get_cocktail.png"
            alt=""
          />
        </div>
        <div class="sendgift-tips">{{ $t('lang.FriendshipLevel.k008') }}</div>

        <div class="send-btn" @click="handleSend">{{ $t('lang.FriendshipLevel.k009') }}</div>
        <div class="later-btn" @click="handleLater">{{ $t('lang.BaseCommon.k019') }}</div>
      </div>
    </div>

    <div v-if="guideShow" class="new-leve-guide">
      <div class="guide-top">
        <div class="guide-btn">
          <div @click.stop="handleGuideOk">{{ $t('lang.BaseCommon.k088') }}</div>
        </div>
        <div class="guide-tip1">{{ $t('lang.FriendshipLevel.k010') }}</div>
        <div class="guide-tip2">{{ $t('lang.FriendshipLevel.k011') }}</div>
        <div class="guide-mark" :style="{ left: `${targetLoc.l + targetLoc.w / 2}px` }">
          <div></div>
        </div>
      </div>
      <div class="guide-middle">
        <template v-if="$i18n.locale === 'ar'">
          <div class="guide-left" style="flex: 1"></div>
          <div class="guide-center" :style="{ width: targetLoc.w + 'px', height: targetLoc.h + 'px' }">
            <div class="guide-view"></div>
            <div class="radius-item radius-item-1">
              <div></div>
            </div>
            <div class="radius-item radius-item-2">
              <div></div>
            </div>
            <div class="radius-item radius-item-3">
              <div></div>
            </div>
            <div class="radius-item radius-item-4">
              <div></div>
            </div>
            <div class="radius-item radius-item-5"></div>
          </div>
          <div class="guide-right" :style="{ width: targetLoc.l + 'px' }" style="width: 100px"></div>
        </template>
        <template v-else>
          <div class="guide-left" :style="{ width: targetLoc.l + 'px' }" style="width: 100px"></div>
          <div class="guide-center" :style="{ width: targetLoc.w + 'px', height: targetLoc.h + 'px' }">
            <div class="guide-view"></div>
            <div class="radius-item radius-item-1">
              <div></div>
            </div>
            <div class="radius-item radius-item-2">
              <div></div>
            </div>
            <div class="radius-item radius-item-3">
              <div></div>
            </div>
            <div class="radius-item radius-item-4">
              <div></div>
            </div>
            <div class="radius-item radius-item-5"></div>
          </div>
          <div class="guide-right" style="flex: 1"></div>
        </template>
      </div>
      <div class="guide-bottom" :style="{ height: targetLoc.b + 'px' }"></div>
    </div>
  </div>
</template>

<script>
// 亲密度说明
import { pageCssVars } from '@/views/P2_Page/FriendshipLevel/z-style-cfg.js'
import { apiIntimacyFriendship, apiDeleteFriendship } from '@/api/imee.js'
import { getDateDiff } from '@/utils/public.js'

import CConfirmAuto from '@/components/CConfirmAuto'
import newLevelGuide from './mixin/new-level-guide.js'

// import mockMixin from './mock/mock.mixin.js'

export default {
  components: {
    ConfirmAuto: CConfirmAuto,
  },
  mixins: [
    newLevelGuide,
    pageCssVars,
    // mock
    // mockMixin,
  ],
  data() {
    const query = this.$route.query
    return {
      data: {},
      rewardList: [],
      time: null,
      targetUid: query.targetUid,
      showMore: false,
      // 1 男 2 女
      gender: null,
      // 左上角的移除关系 确认弹窗
      showConfirmAuto: false,
      title: this.$t('lang.FriendshipLevel.k003'),
      removeCon1: this.$t('lang.FriendshipLevel.k001'),
      removeCon2: this.$t('lang.FriendshipLevel.k002'),
      leftBtnText: this.$t('lang.BaseCommon.k007'),
      rightBtnText: this.$t('lang.BaseCommon.k006'),

      showProp: false,
      chooseBlockGender: 0,
      chooseBlockProps: [],
      propsList: [],

      rewardListNew: [],
    }
  },
  computed: {
    percentageVal() {
      if (this.data.score === undefined || this.data.nextGradeMinScore === undefined) {
        return 0
      }

      const percentage = (this.data.score / this.data.nextGradeMinScore) * 100
      return percentage > 100 ? 100 : percentage
    },
    progressBarColor() {
      const v = this.cssVars()
      return v['--fl-progress-color'] || '#A338FC'
    },
    progressBarTrackColor() {
      const v = this.cssVars()
      return v['--fl-progress-track'] || '#ffe9fc'
    },
    content() {
      const v = this.cssVars()
      const c = v['--fl-primary'] || '#a338fc'
      return `${this.removeCon1}<i style="color:${c}">${this.data.targetNickname} </i>${this.removeCon2}`
    },
  },
  methods: {
    // 亲密度数据
    fetchIntimacyDiary(needUnreceiveGuide) {
      // 对方的uid字段
      if (this.targetUid) {
        apiIntimacyFriendship(this.targetUid).then((res) => {
          if (res) {
            this.data = res
            this.time = getDateDiff(res.videoCallTimeSeconds)

            if (res.rewards) {
              this.rewardList = res.rewards || []
            }

            if (res.rewardsV2) {
              try {
                // 新好友权益数据转换
                const rewardKes = Object.keys(res.rewardsV2)
                const arr = []
                rewardKes.forEach((keyItem) => {
                  const tarObj = {
                    grade: keyItem.replace('GRADE_', ''),
                    children: res.rewardsV2[keyItem].map((ele) => {
                      return {
                        ifTakeReward: ele.ifTakeReward,
                        ...ele.propInfo,
                      }
                    }),
                  }
                  if (tarObj.grade) {
                    tarObj.grade = tarObj.grade * 1
                  }
                  arr.push(tarObj)
                })

                this.rewardListNew = arr

                // 未领取引导
                let hasUnreceiveGift = false
                if (needUnreceiveGuide) {
                  let unReceiveObj = null
                  let typeIndex = -1
                  this.rewardListNew.forEach((item) => {
                    if (item.children && !unReceiveObj) {
                      if (item.children[0] && !item.children[0].ifTakeReward) {
                        unReceiveObj = item
                        typeIndex = 0
                        return
                      }
                      if (item.children[1] && !item.children[1].ifTakeReward) {
                        unReceiveObj = item
                        typeIndex = 1
                      }
                    }
                  })
                  const genderMap = {
                    1: 'male',
                    2: 'female',
                  }
                  hasUnreceiveGift = unReceiveObj && genderMap[this.data.fromGender] && unReceiveObj.grade <= this.data.grade
                  if (hasUnreceiveGift) {
                    setTimeout(() => {
                      const targetId = `${genderMap[this.data.fromGender]}-grade${unReceiveObj.grade}-type${typeIndex}`
                      this.locationTarget(targetId, () => {
                        this.calculatePos(targetId)
                      })
                    }, 1000)
                  }
                }

                const storeMark = window.localStorage.getItem(`newFriendShowed_${this.data.fromUid}`)
                if (this.data.ifNewRuleFriend && storeMark !== 'showed') {
                  this.showNewfriendship = true
                  window.localStorage.setItem(`newFriendShowed_${this.data.fromUid}`, 'showed')
                  if (hasUnreceiveGift) {
                    this.laterShowNewfriendship = true
                  }
                }
              } catch (err) {
                this.rewardListNew = []
              }
            }

            // 埋点
            this.$client.addEvent('ep_bond_level_page', { bond_level: res.grade, from_uid: res.fromUid, to_uid: res.targetUid })
          }
        })
      }
    },
    // more 右上角
    handleMore() {
      this.showMore = !this.showMore
    },

    // 去亲密度规则页面
    handleToRule() {
      this.$router.push({
        path: '/friendship-level-rule',
        query: {
          fromPage: 'friendship-level',
          targetUid: this.targetUid,
        },
      })
    },
    // 关闭消息确认弹框
    closeAutoDia() {
      this.showConfirmAuto = false
    },

    // 亲密度 移除绑定关系
    deleteBond() {
      apiDeleteFriendship(this.targetUid).then((res) => {
        if (res) {
          this.closeAutoDia()
          // 退出页面
          this.closeWeb()
          this.$client.addEvent('remove_bond', { bond_level: this.data.grade, from_uid: this.data.fromUid, to_uid: this.data.targetUid })
        }
      })
    },

    leftBtn() {
      // 移除关系
      this.deleteBond()
    },
    rightBtn() {
      // 关闭弹框
      this.closeAutoDia()
    },
    aboutBond() {
      this.handleToRule()
    },
    removeBond() {
      this.showConfirmAuto = true
    },

    // 点击打开的宝箱
    rewardProp(props, gender) {
      this.propsList = props
      this.chooseBlockGender = gender
      this.showProp = true
    },
    closeProp() {
      this.showProp = false
    },
  },
  created() {
    this.fetchIntimacyDiary(true)
  },
}
</script>
<style lang="scss" scoped>
// 数字/等级数据统一使用
.friendship-num-font {
  font-family: var(--number-font) !important;
}

.friendship-level-root {
  width: 100%;
  min-height: 100vh;
  background: var(--fl-page-base) var(--fl-bg-page) top left / 100% 234px no-repeat;

  .custom-nav-block {
    background: var(--fl-bg-page) top left / 100% 234px no-repeat;

    .more-btn {
      position: relative;
      > img {
        width: 24px;
      }
      .more-list {
        position: absolute;
        top: 23px;
        right: 3px;
        padding: 16px 21px;
        background: var(--fl-more-bg);
        border-radius: var(--fl-more-radius);
        .span1,
        .span2 {
          display: block;
          height: 30px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          color: var(--fl-text-strong);
          line-height: 20px;
          white-space: nowrap;
          text-align: left;
        }
        .span2 {
          padding-top: 10px;
        }
        .line {
          width: 100%;
          height: 1px;
          background-color: var(--fl-divider);
        }
      }
    }

    ::v-deep .van-nav-bar__title {
      color: var(--fl-nav-title);
      font-family: var(--string-font);
    }
  }

  .fade-enter-to,
  .fade-leave {
    opacity: 1;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .avatar {
    width: 100%;
    margin-top: 43px;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      width: 50px;
      height: 50px;
      border-radius: var(--fl-avatar-radius);
      border: 1px solid var(--fl-avatar-border);
    }
    .level-love {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      min-width: 100px;
      height: 50px;
      padding: 0 12px;
      .level-num {
        font-size: var(--fs-24);
        font-family: var(--string-font);
        font-weight: var(--fw-500);
        line-height: var(--lh-body-32);
        color: var(--fl-primary);
        text-align: center;
      }
      .intimate-value {
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        color: var(--fl-text-secondary);
        line-height: var(--lh-body-24);
        text-align: center;
      }
    }
  }
  .progress {
    width: 100%;
    padding: 0 16px;
    margin: 47px auto 0;
    .progress-item {
      position: relative;
      height: 14px !important;
      .progress-bar {
        height: 14px !important;
        box-shadow: inset 0px 0px 3px 0px var(--fl-progress-shadow);
        border-radius: var(--fl-progress-radius);
      }
      .progress-text {
        position: absolute;
        top: 0;
        right: 10px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-10);
        color: var(--fl-primary);
        line-height: 14px;
      }
    }
    ::v-deep .van-progress__portion {
      border-radius: var(--fl-progress-inner-radius);
    }
  }
  .level {
    width: 100%;
    padding: 0 16px;
    margin-top: 8px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .level-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: var(--fw-500);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      font-family: var(--string-font);
      color: var(--fl-text-muted);
      &.current-level {
        color: var(--fl-primary);
      }
    }
    .level-tip {
      max-width: 50%;
      padding: 0 3px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-18);
      font-size: var(--fs-12);
      color: var(--fl-text-muted);
      word-break: break-all;
      word-wrap: break-word;
      text-align: center;
      > img {
        width: 12px;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
  }

  .content {
    width: 100%;
    padding: 24px 16px 30px;

    .days {
      position: relative;
      width: 100%;
      height: 142px;
      margin: 0 auto 24px;
      padding-top: 30px;
      background: var(--fl-bg-page-day) no-repeat center top / 100% 100%;
      .days-text {
        display: flex;
        justify-content: space-around;
      }
      .days-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: var(--fs-14);
        font-family: var(--string-font);
        > span {
          margin-bottom: 12px;
          font-weight: var(--fw-400);
          color: var(--fl-text-strong);
          line-height: var(--lh-body-20);
        }
        > i {
          font-weight: var(--fw-600);
          color: var(--fl-primary);
        }
      }
      .last-chat-time {
        position: absolute;
        bottom: 10px;
        left: 10px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        color: var(--fl-text-muted);
        line-height: 20px;
      }
    }

    .reward-list {
      width: 100%;
      min-height: 193px;
      padding-bottom: 30px;
      background: var(--fl-reward-panel-bg);
      border-radius: var(--fl-reward-panel-radius);
      border: 1px solid var(--fl-reward-panel-border);

      > .title {
        display: flex;
        justify-content: center;
        font-size: var(--fs-16);
        font-family: var(--string-font);
        font-weight: var(--fw-500);
        color: var(--fl-title-banner);
        > img {
          width: 30px;
          height: 30px;
          &:first-child {
            margin-right: -1px;
          }
          &:last-child {
            margin-left: -1px;
          }
        }
        .tit {
          min-width: 80px;
          padding: 0 12px;
          text-align: center;
          height: 30px;
          line-height: 30px;
          background-color: var(--fl-accent-soft);
        }
      }
      .reward-tit-agent {
        width: 100%;
        height: 12px;
        margin-top: 4px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-10);
        color: var(--fl-text-muted);
        line-height: 12px;
        text-align: center;
        font-style: normal;
      }

      .reward-item-grade-1 {
        height: 25px;
      }
      .reward-item-row {
        display: flex;
        margin-left: 0px;
        margin: 10px 0;
        align-items: center;
        justify-content: center;
        .reward-box {
          width: 70px !important;
          height: 70px !important;
        }
        .reward-text {
          margin-top: 14px !important;
          font-size: var(--fs-14) !important;
        }
      }

      .reward-item {
        position: relative;
        width: 115px;
        height: 94px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .reward-img {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 20px;
          .reward-box {
            position: relative;
            width: 40px;
            height: 40px;
            .status-icon {
              position: absolute;
              right: -16px;
              bottom: 0;
              width: 16px;
              height: 16px;
            }
          }
          .reward-status {
            position: absolute;
            right: -16px;
            bottom: 0;
            width: 16px;
            height: 16px;
          }
          ::v-deep .ivu-tooltip-popper[x-placement^='top'] .ivu-tooltip-arrow {
            border-top-color: var(--fl-tooltip-arrow) !important;
            left: 45px !important;
          }
          ::v-deep .ivu-tooltip-inner {
            background-color: var(--fl-tooltip-bg);
            color: var(--fl-tooltip-text);
            padding: 8px 10px;
          }
          ::v-deep .ivu-tooltip-popper {
            left: -30px !important;
          }
        }
        .reward-text {
          height: 20px;
          margin-top: 4px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-12);
          color: var(--fl-text-secondary);
          line-height: 20px;
          text-align: center;
        }
        .no-reward-text {
          color: var(--fl-text-muted);
        }
      }
      .reward-item:nth-child(1) {
        margin: 20px !important;
      }
      // 步骤图 v1 / v2 样式各自独立，不共用选择器
      .steps-box.step-v1 {
        margin-top: 27px;

        .step-item-rewards {
          display: flex;
          margin-left: -20px;
        }

        .privilege-root {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          width: fit-content;
          height: fit-content;
          .privilege-wrapper {
            width: 115px;
            height: fit-content;
            .privilege-item {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 100%;
              height: fit-content;
              .image-wrapper {
                position: relative;
                width: 40px;
                height: 40px;
                .status-icon {
                  position: absolute;
                  right: -16px;
                  bottom: 0;
                  width: 16px;
                  height: 16px;
                }
              }
              .title {
                width: fit-content;
                height: fit-content;
                max-width: 100px;
                margin-top: 4px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                color: var(--fl-text-secondary);
                text-align: center;
              }
              .no-reward-text {
                color: var(--fl-text-muted) !important;
              }
            }
          }
        }

        .treasure-root {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          width: fit-content;
          height: fit-content;
          .privilege-wrapper {
            width: 115px;
            height: fit-content;
            .privilege-item {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 100%;
              height: fit-content;
              .image-wrapper {
                position: relative;
                width: 40px;
                height: 40px;
                .status-icon {
                  position: absolute;
                  right: -16px;
                  bottom: 0;
                  width: 16px;
                  height: 16px;
                }
              }
              .title1 {
                width: fit-content;
                height: fit-content;
                max-width: 100px;
                margin-top: 4px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-12);
                color: var(--fl-text-secondary);
                text-align: center;
              }
              .title2 {
                width: 100%;
                height: 12px;
                margin-top: 4px;
                font-family: var(--string-font);
                font-weight: var(--fw-400);
                font-size: var(--fs-10);
                color: var(--fl-text-muted);
                line-height: 12px;
                text-align: center;
                font-style: normal;
              }
              .no-reward-text {
                color: var(--fl-text-muted) !important;
              }
            }
          }
        }

        .from-gender-hide {
          ::v-deep .van-step__line {
            display: none !important;
          }
          ::v-deep .van-step__circle-container {
            display: none !important;
          }
        }

        .no-show-point-grade-1 {
          ::v-deep .van-step__circle-container {
            .van-step__circle {
              display: none !important;
            }
            .van-step__icon--active {
              display: none !important;
            }
          }
        }

        ::v-deep .van-steps--vertical {
          overflow: visible;
          background-color: transparent;
          padding: 0 0 0 100px;

          .van-step--vertical {
            padding: 5px 0px;

            &:not(:last-child) {
              &::after {
                border-bottom-width: 0px !important;
              }
            }

            .van-step__title {
              position: relative;

              .reward-level {
                position: absolute;
                left: -100px;
                top: 3px;
                width: 70px;
                text-align: center;
              }
            }

            .van-step__circle-container {
              top: 16px;
              left: -22px;
              z-index: 10;
              .van-step__icon--active {
                width: 10px;
                height: 10px;
                &::before {
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  width: 11px;
                  height: 11px;
                  font-size: 11px;
                }
              }
            }

            .van-step__circle {
              width: 10px;
              height: 10px;
              background-color: var(--fl-step-line);
            }

            .van-step__line {
              left: -24px;
              z-index: 9;
              width: 4px;
              border-radius: var(--fl-step-line-radius);
              background-color: var(--fl-step-line);
            }

            .van-step__title--active {
              color: var(--fl-step-active-title);
            }

            .van-step__icon--active {
              color: var(--fl-step-line);
            }
          }

          .van-step--finish {
            .van-step__line {
              width: 4px;
              background-color: var(--fl-step-line);
            }
            .van-step__circle {
              background-color: var(--fl-step-line);
            }
          }
        }
      }

      .steps-box.step-v2 {
        margin-top: 27px;
        position: relative;

        .step-item-rewards {
          display: flex;
          margin-top: 30px;

          .reward-level {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 10px;
            width: 80px;
            font-family: var(--string-font);
            font-size: var(--fs-14);
            color: var(--fl-text-muted);
            word-wrap: break-word;
          }

          .privilege-root {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            width: fit-content;
            height: fit-content;

            .privilege-wrapper {
              width: 115px;
              height: fit-content;

              .privilege-item {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                width: 100%;
                height: fit-content;

                .image-wrapper {
                  position: relative;
                  width: 40px;
                  height: 40px;

                  .status-icon {
                    position: absolute;
                    right: -16px;
                    bottom: 0;
                    width: 16px;
                    height: 16px;
                  }
                }

                .title {
                  width: fit-content;
                  height: fit-content;
                  max-width: 115px;
                  margin-top: 4px;
                  font-family: var(--string-font);
                  font-weight: var(--fw-400);
                  font-size: var(--fs-12);
                  color: var(--fl-text-secondary);
                  text-align: center;
                }

                .no-reward-text {
                  color: var(--fl-text-muted) !important;
                }
              }
            }
          }
        }

        .step-item-rewards:empty {
          display: none;
        }

        .reward-bar {
          width: 4px;
          height: 100%;
          background: var(--fl-step-line);
          border-radius: var(--fl-step-line-radius);
          position: absolute;
          top: 0;
          left: 80px;
        }
      }
    }
  }

  .popup-box {
    width: 300px;
    padding: 20px;
    background: var(--fl-popup-surface);
    border-radius: var(--fl-popup-radius);
    .prop-tit {
      width: 100%;
      font-family: var(--string-font);
      font-weight: var(--fw-600);
      font-size: var(--fs-16);
      color: var(--fl-text-strong);
      line-height: 20px;
      text-align: center;
    }
    .prop {
      width: 100%;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      margin: 10px 0;
      .prop-content {
        width: 31%;
        padding: 15px 0;
        display: inline-block;
        display: flex;
        flex-direction: column;
        align-items: center;
        > img {
          width: 46px;
          height: 46px;
          object-fit: contain;
        }
        .coupon-text {
          position: relative;
          height: 20px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-12);
          color: var(--fl-text-strong);
          line-height: 20px;
          text-align: center;
          .tip {
            width: 100%;
            display: block;
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            color: var(--fl-text-muted);
            font-size: var(--fs-10);
            white-space: nowrap;
          }
        }
      }
      &.prop-num::after {
        flex: auto;
        content: '';
        width: 31%;
        height: 0;
      }
    }
    .close-btn {
      width: 249px;
      height: 40px;
      margin: 20px auto 0;
      background: var(--fl-btn-fill);
      border-radius: var(--fl-popup-btn-radius);
      font-family: var(--string-font);
      font-weight: var(--fw-600);
      font-size: var(--fs-16);
      color: var(--fl-btn-fill-text);
      line-height: 40px;
      text-align: center;
    }
  }

  ::v-deep .ivu-tooltip-popper[x-placement^='bottom'] .ivu-tooltip-arrow {
    border-bottom-color: var(--fl-tooltip-arrow) !important;
    left: 43px !important;
  }

  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    background: var(--fl-dialog-overlay);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  .friendship-dialog {
    width: 315px;
    padding: 0 6px 6px 6px;
    background: var(--fl-dialog-shell);
    border-radius: var(--fl-dialog-shell-radius);
    .friendship-dia-head {
      width: 100%;
      height: 49px;
      position: relative;
      span {
        display: inline-block;
        font-family: var(--string-font);
        font-size: var(--fs-40);
        color: var(--fl-dialog-head-fade);
        line-height: 49px;
        font-style: italic;
        font-weight: var(--fw-700);
        text-indent: 10px;
      }
      img {
        width: 143px;
        height: 65px;
        position: absolute;
        right: -10px;
        bottom: 0;
      }
    }
    .friendship-dia-bd {
      background: var(--fl-dialog-body);
      border-radius: var(--fl-dialog-body-radius);
      overflow: hidden;
      margin-top: 5px;

      .my-swipe {
        ::v-deep .van-swipe__indicators {
          .van-swipe__indicator {
            width: 30px;
            height: 4px;
            background: var(--fl-swipe-dot) !important;
            border-radius: var(--fl-swipe-dot-radius);
          }
          .van-swipe__indicator--active {
            background: var(--fl-swipe-dot-on) !important;
          }
        }
      }
    }
    .friendship-dia-con {
      width: 303px;
      min-height: 275px;
      padding: 24px 16px;
      margin: 0 auto;
      background: var(--fl-dialog-body);
      border-radius: var(--fl-dialog-body-radius);
      .friendship-dia-tit {
        width: 100%;
        line-height: 24px;
        font-family: var(--string-font);
        font-size: var(--fs-20);
        color: var(--fl-text-strong);
        text-align: center;
      }
      .friendship-tips {
        width: 100%;
        line-height: 22px;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        color: var(--fl-text-secondary);
        font-style: italic;
        margin-top: 24px;
      }
      .friendship-rewards {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 32px;
        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
          img {
            width: 64px;
            height: 64px;
          }
          span {
            font-family: var(--string-font);
            font-size: var(--fs-16);
            color: var(--fl-text-strong);
            line-height: 22px;
          }
        }
      }
    }
    .ok-btn {
      width: 243px;
      line-height: 48px;
      margin: 20px auto 30px;
      background: var(--fl-dialog-ok);
      border-radius: var(--fl-dialog-ok-radius);
      font-family: var(--string-font);
      font-size: var(--fs-16);
      color: var(--fl-btn-fill-text);
      text-align: center;
    }
  }

  .sendgift-dialog {
    width: 315px;
    padding: 30px 16px;
    background: var(--fl-send-panel-bg);
    border-radius: var(--fl-send-panel-radius);
    .sendgift-tit {
      width: 100%;
      line-height: 24px;
      font-family: var(--string-font);
      font-size: var(--fs-20);
      color: var(--fl-text-strong);
      text-align: center;
    }
    .sendgift-rewards {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      img {
        width: 100px;
        height: 100px;
      }
    }

    .sendgift-tips {
      width: 283px;
      height: 19px;
      margin-top: 16px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-16);
      color: var(--fl-text-secondary);
      line-height: 19px;
      text-align: center;
      font-style: normal;
    }

    .send-btn {
      width: 255px;
      line-height: 48px;
      background: var(--fl-send-primary);
      border-radius: var(--fl-send-primary-radius);
      padding: 14px 0;
      margin: 16px auto 0;

      font-family: var(--string-font);
      font-size: var(--fs-16);
      color: var(--fl-btn-fill-text);
      line-height: 20px;
      text-align: center;
    }

    .later-btn {
      width: 255px;
      line-height: 48px;
      padding: 14px 0;
      margin: 16px auto 0;
      background: var(--fl-send-secondary-bg);
      border-radius: var(--fl-send-secondary-radius);

      font-family: var(--string-font);
      font-size: var(--fs-16);
      color: var(--fl-send-secondary-text);
      line-height: 20px;
      text-align: center;
      border: 1px solid var(--fl-send-secondary-border);
    }
  }

  .new-leve-guide {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    .guide-top {
      width: 100%;
      flex: 1;
      background-color: var(--fl-guide-scrim);
      position: relative;

      .guide-btn {
        text-align: right;
        position: absolute;
        right: 0;
        bottom: 110px;
        padding-right: 38px;
        div {
          display: inline-block;
          padding: 6px 26px;
          border-radius: var(--fl-guide-chip-radius);
          border: 1px solid var(--fl-guide-chip-border);
          font-family: var(--string-font);
          font-size: var(--fs-16);
          color: var(--fl-on-dark);
          line-height: 18px;
        }
      }

      .guide-tip1 {
        position: absolute;
        right: 0;
        bottom: 70px;
        width: 100%;
        line-height: 24px;
        font-family: var(--string-font);
        font-size: var(--fs-20);
        color: var(--fl-on-dark);
        text-indent: 30px;
      }

      .guide-tip2 {
        position: absolute;
        right: 0;
        bottom: 47px;
        width: 100%;
        line-height: 19px;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        color: var(--fl-on-dark);
        text-indent: 30px;
      }

      .guide-mark {
        width: 16px;
        height: 37px;
        position: absolute;
        left: 133px;
        bottom: 0;
        margin-left: -8px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        div {
          width: 6px;
          height: 6px;
          box-sizing: content-box;
          border-radius: var(--fl-avatar-radius);
          background: var(--fl-guide-dot);
          border: 5px solid var(--fl-guide-dot-ring);
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 3px;
            left: 2px;
            width: 2px;
            height: 32px;
            background: var(--fl-guide-line);
          }
        }
      }
    }
    .guide-middle {
      width: 100%;
      display: flex;
      outline: none;
      .guide-left {
        background-color: var(--fl-guide-scrim);
      }
      .guide-center {
        width: 80px;
        height: 75px;
        position: relative;
        .guide-view {
          box-sizing: content-box;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .radius-item {
          width: 7px;
          height: 7px;
          background-color: var(--fl-guide-scrim);
          position: absolute;
          div {
            width: 8px;
            height: 8px;
            background-color: var(--fl-guide-dot);
            position: absolute;
          }
        }
        .radius-item-1 {
          top: 0;
          left: 0;
          div {
            border-top-left-radius: var(--fl-corner-mask-radius);
            top: 0;
            left: 0;
          }
        }
        .radius-item-2 {
          top: 0;
          right: 0;
          div {
            border-top-right-radius: var(--fl-corner-mask-radius);
            top: 0;
            right: 0;
          }
        }
        .radius-item-3 {
          bottom: 0;
          left: 0;
          div {
            border-bottom-left-radius: var(--fl-corner-mask-radius);
            bottom: 0;
            left: 0;
          }
        }
        .radius-item-4 {
          bottom: 0;
          right: 0;
          div {
            border-bottom-right-radius: var(--fl-corner-mask-radius);
            bottom: 0;
            right: 0;
          }
        }
        .radius-item-5 {
          top: 7px;
          left: 0;
          width: 7px;
          height: calc(100% - 14px);
          background-color: var(--fl-guide-dot);
        }
      }
      .guide-right {
        background-color: var(--fl-guide-scrim);
      }
    }
    .guide-bottom {
      width: 100%;
      height: 90px;
      background-color: var(--fl-guide-scrim);
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .friendship-level-root {
    .custom-nav-block {
      .more-btn {
        padding: 0 0 0 16px;

        .more-list {
          right: auto;
          left: 20px;
          border-radius: 0px 12px 12px 12px;
        }
      }
    }

    .content {
      .days {
        .last-chat-time {
          right: 10px;
          left: auto;
        }
      }
    }

    .reward-list {
      > .title {
        > img {
          transform: rotateY(-180deg);
          &:first-child {
            margin-left: -1px;
          }
          &:last-child {
            margin-right: -1px;
          }
        }
      }

      .steps-box.step-v1 {
        ::v-deep .van-steps--vertical {
          padding: 0 100px 0 0;
          .van-step--vertical {
            .van-step__title {
              .reward-level {
                left: unset;
                right: -100px;
              }
            }

            .van-step__circle-container {
              left: unset;
              right: -32px;
            }

            .van-step__line {
              left: unset;
              right: -24px;
            }
          }
        }
      }

      .steps-box.step-v2 {
        .step-item-rewards:empty {
          display: none;
        }
        .reward-bar {
          right: 80px;
          left: auto;
        }
      }
    }

    .new-leve-guide {
      .guide-top {
        .guide-btn {
          left: 0;
          right: auto;
          padding-left: 38px;
        }

        .guide-tip1 {
          left: 0;
          right: auto;
          text-align: left;
          padding-left: 30px;
        }

        .guide-tip2 {
          left: 0;
          right: auto;
          text-align: left;
          padding-left: 30px;
        }
      }

      .guide-middle {
        .guide-center {
          .radius-item-5 {
            left: unset;
            right: 0;
          }
        }
      }
    }

    .friendship-dialog {
      .friendship-dia-head {
        img {
          width: 115px;
          height: auto;
          right: unset;
          left: -10px;
          bottom: 5px;
          transform: rotateY(-180deg);
        }
      }
    }
  }
}
</style>
